import { render, staticRenderFns } from "./DetailPaymentGeneralKasbon.vue?vue&type=template&id=532116c5"
import script from "./DetailPaymentGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./DetailPaymentGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports